import React, { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { ArrowRightIcon } from "lucide-react";
import { CHECKOUT_URL } from "../data/content";
import { trackCheckout } from "./CtaButton";
type FloatingCtaProps = {
  anchorId: string;
};
export function FloatingCta({
  anchorId
}: FloatingCtaProps) {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const check = () => {
      const anchor = document.getElementById(anchorId);
      if (!anchor) return;
      setVisible(anchor.getBoundingClientRect().bottom < 0);
    };
    check();
    window.addEventListener("scroll", check, {
      passive: true
    });
    window.addEventListener("resize", check);
    return () => {
      window.removeEventListener("scroll", check);
      window.removeEventListener("resize", check);
    };
  }, [anchorId]);
  return <AnimatePresence data-id="element-32" data-mp="197ztwthdd6tz">
      {visible && <motion.div className="fixed inset-x-0 bottom-0 z-50 bg-navy-950/95 px-3 pb-[calc(env(safe-area-inset-bottom)+12px)] pt-3 backdrop-blur" initial={{
      y: "100%"
    }} animate={{
      y: 0
    }} exit={{
      y: "100%"
    }} transition={{
      duration: 0.25,
      ease: [0.23, 1, 0.32, 1]
    }} data-id="element-33" data-mp="14ef3bmi3vf4t">
          <a href={CHECKOUT_URL} onClick={trackCheckout} className="animate-shake mx-auto flex w-full max-w-xl items-center justify-center gap-2 rounded-xl bg-gold-400 px-4 py-4 text-base font-extrabold uppercase tracking-wide text-navy-950 focus:outline-none focus-visible:ring-4 focus-visible:ring-gold-300" data-id="element-34" data-mp="21cdsffirc2s3">
            <span className="whitespace-nowrap" data-id="element-35" data-mp="1iejnbckr2bez">Get it now — only $27</span>
            <ArrowRightIcon className="h-5 w-5 shrink-0" aria-hidden="true" data-id="element-36" data-mp="1ncuz3suluvzu" />
          </a>
        </motion.div>}
    </AnimatePresence>;
}